import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

const store = new Vuex.Store({

	state: {
		// Is the user signed in with google
		authenticated: false,
		// Firebase user info (some)
		user: {
			email: null,
			displayName: null,
			photoURL: null
		},
		groups: null,
		// a group
		group: {
			name: null,
			email: null,
			members: null,
		},
		// Is the user allowed into the app
		authorized: false,
		// Is the user in the database/administrator list
		administrator: false,
		token: null,
		// Which person has the user selected
		selectedPersonKey: null,
		selectedPersonVehicles: [],
		selectedPersonIsUser: false,
		selectedGroupKey: null,
		selectedGroup: {
			name: null,
			email: null,
			members: null,
		},
		memberships: null,
		selectedGroupMembers: null,
		selectedMemberKey: null,
		selectedMember: null,
		selectedMemberships: null,
		selectedSlackMember: null,
		selectedSlackMemberships: null,
		// a person
		person: {
			// Contact
			active: null,
			email: null,
			fName: null,
			lName: null,
			nName: null,
			title: null,
			phone1: null,
			phone2: null,
			email1: null,
			email2: null,
			street: null,
			city: null,
			zip: null,
			// Emergency
			emergencyName: null,
			emergencyRelationship: null,
			emergencyPhone1: null,
			emergencyPhone2: null,
			// Vehicle
			vehicleMakeModel: null,
			licensePlateNumber: null,
			// Administration
			id: null,
			birthDate: null,
			startDate: null,
			status: null,
			group: null,
			shareBirthDate: null,
			kelmarId: null,
			teamPage: null,
			selectedProjectKey: null,
			onsipExtension: null,
		},
		/*
		 * vehicles[]
		 *
		 * color: string
		 * licensePlateNumber: string
		 * licensePlateState: string
		 * make: string
		 * model: string
		 * userKey: string
		 * vehicleKey: string
		 */
		vehicles: [],
		/*
		 * people[]
		 *
		 * active
		 * activeClockify
		 * activeSlack
		 * activeToggl
		 * birthDate
		 * city
		 * docusign
		 * email
		 * email1
		 * email2
		 * emergencyName
		 * emergencyPhone1
		 * emergencyPhone2
		 * emergencyRelationship
		 * fName
		 * group
		 * id
		 * kelmarId
		 * licensePlateNumber
		 * lName
		 * nName
		 * onsipExtension
		 * phone1
		 * phone2
		 * shareBirthDate
		 * skills
		 * startDate
		 * status
		 * street
		 * teamPage
		 * title
		 * vehicleMakeModel
		 * zip
		 */
		people: null,
		/*
		 * technology[]
		 * 
		 *	CanonicalUrl: string - stackshare url
		 *	Category: string - Business Tools, DevOps, etc
		 *	Core: true/false - is tech core to JG 
		 *	Count: number
		 *	Description: string - description of tech
		 *	Id: sting - ??
		 *	ImageUrl: string - image url
		 *	Name: string - skill name
		 *	OssRepo: string - ??
		 *	Slug: string - for stackshare url ??
		 *	Title: string - from stackshare ??
		 *	WebsiteUrl: sting - website url
		 */
		technology: [],
		// An object with person keys corresponding to the people with skills
		skillsRatingByTechnology: [],
		skillsRatingByPerson: null,
		// An object with skills keys corresponding to skills a person rated themselves on
		selectedPersonSkillsRating: null,
		// People with a birthday this month
		birthdaysThisMonth: null,
		anniversariesThisMonth: null,
		// TODO !! remove the stuff below here
		togglProjects: {
			billable: null,
			cName: null,
			name: null,
			cid: null,
			wid: null
		},
		projectsManagementOverview: {
			cName: null,
			name: null,
			leadName: null,
			updateStatus: null,
			updateTimestamp: null
		},
		projectsManagementDetails: {
			billable: null,
			cName: null,
			cid: null,
			id: null,
			leadName: null,
			name: null,
			updateStatus: null,
			updateText: null,
			updateTimestamp: null,
			wid: null
		},
		selectedProjectKey: null,
		project: {
			cName: null,
			name: null,
			lead: null,
			status: null,
			updated: null
		},
	},
	getters,
	mutations,
	actions
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js